import {
  FormControlLabel,
  Grid2 as Grid,
  Paper,
  Switch,
  TextField,
  Typography
} from '@mui/material'
import React, { Fragment, useEffect, useState } from 'react'
import { TypeVas, TypeVasUpdate } from '../../../interfaces/TypeVas/TypeVas'
import { Loading } from '../../../components/UI'
import { Status } from '../../../hooks/useFetchState'
import { updateTypeVas } from '../config/api'
import { useApi } from '../../../hooks/useApi'
import { Filter } from '../../../components/_WMS/FilterComponent'

interface EditTypeVasModalProps {
  typeVas: TypeVas
  handleSnackbar: (message: string, success: boolean) => void
  handleCloseModal: () => void
  requestTypeVas: (filters?: Filter[], page?: number, pageSize?: number) => void
  submitRef?: React.MutableRefObject<(() => void) | null>
  isFormReadyRef?: React.MutableRefObject<boolean>
}

export const EditTypeVasModal: React.FC<EditTypeVasModalProps> = ({
  typeVas,
  handleSnackbar,
  handleCloseModal,
  requestTypeVas,
  submitRef,
  isFormReadyRef
}) => {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [active, setActive] = useState(false)
  const { state, callApi } = useApi()

  const handleSubmit = async () => {
    const finalValues: TypeVasUpdate = {
      active: active,
      description: description.trim(),
      name: name.trim()
    }

    callApi(updateTypeVas(typeVas.typeVasId, finalValues))
      .then(() => {
        requestTypeVas()
        handleSnackbar('Entidad editada correctamente', true)
        handleCloseModal()
      })
      .catch((error) => {
        handleSnackbar('Error al editar: ' + error, false)
      })
  }

  useEffect(() => {
    if (typeVas) {
      setName(typeVas.name)
      setDescription(typeVas.description)
      setActive(typeVas.active)
    }
  }, [typeVas])

  const isDisableButton = () => {
    return (
      name.trim().length === 0 ||
      name.trim().length > 50 ||
      description.trim().length === 0 ||
      description.trim().length > 50
    )
  }

  if (submitRef) submitRef.current = handleSubmit
  if (isFormReadyRef) isFormReadyRef.current = !isDisableButton()

  const validateDescription = () => {
    return description.trim().length === 0 || description.trim().length > 50
  }

  const validateName = () => {
    return name.trim().length === 0 || name.trim().length > 50
  }

  if (state.status === Status.Loading) {
    return (
      <div>
        <Typography>
          <Loading />
        </Typography>
      </div>
    )
  }

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid size={12}>
          <TextField
            id='Name'
            label='Código'
            value={name}
            onChange={(e) => setName(e.target.value)}
            variant='outlined'
            fullWidth
            placeholder='EJ. SERIAL_NUMBER'
            error={validateName()}
            helperText={
              validateName()
                ? 'el campo Código debe tener entre 1 y 50 caracteres'
                : ''
            }
          />
        </Grid>

        <Grid size={12}>
          <TextField
            id='Description'
            label='Descripción'
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            variant='outlined'
            fullWidth
            placeholder='Descripción del servicio'
            error={validateDescription()}
            helperText={
              validateDescription()
                ? 'el campo Descripción debe tener entre 1 y 50 caracteres'
                : ''
            }
          />
        </Grid>

        <Grid size={12}>
          <Paper
            variant='outlined'
            style={{
              width: '96%',
              padding: '10px 10px',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              {/* Label a la izquierda */}
              <Typography
                variant='subtitle1'
                style={{ fontWeight: 600, width: 80 }}
              >
                Estado
              </Typography>

              {/* Switch + Activo/Inactivo */}
              <FormControlLabel
                style={{ marginLeft: 10 }}
                label={
                  <Typography
                    style={{
                      fontWeight: 600,
                      color: active ? '#4caf50' : '#757575'
                    }}
                  >
                    {active ? 'Activo' : 'Inactivo'}
                  </Typography>
                }
                control={
                  <Switch
                    checked={active}
                    onChange={(e) => setActive(e.target.checked)}
                    color='primary'
                  />
                }
              />
            </div>

            {/* Texto inferior aclaratorio */}
            <Typography
              variant='caption'
              style={{
                marginTop: 8,
                color: '#888'
              }}
            >
              Activar o desactivar este tipo de VAS
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Fragment>
  )
}
